import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Mail, Phone, MapPin, Instagram, Twitter, Linkedin } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-primary-950 text-neutral-300 pt-16 pb-8" data-id="element-170">
      <div className="container mx-auto px-4 md:px-6" data-id="element-171">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-172">
          {/* Brand */}
          <div data-id="element-173">
            <Link to="/" className="flex items-center gap-2 mb-6" data-id="element-174">
              <div className="w-8 h-8 rounded bg-secondary flex items-center justify-center font-serif font-bold text-xl text-primary-900" data-id="element-175">
                A
              </div>
              <span className="font-serif font-bold text-2xl tracking-tight text-white" data-id="element-176">
                AMU
              </span>
            </Link>
            <p className="text-sm leading-relaxed mb-6" data-id="element-177">
              The premium Abuja real estate marketplace. Discover verified land
              and property listings directly from trusted owners and authorized
              sellers.
            </p>
            <div className="flex items-center gap-4" data-id="element-178">
              <a href="#" className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-secondary hover:text-white transition-colors" data-id="element-179">
                <Instagram size={16} data-id="element-180" />
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-secondary hover:text-white transition-colors" data-id="element-181">
                <Twitter size={16} data-id="element-182" />
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-secondary hover:text-white transition-colors" data-id="element-183">
                <Linkedin size={16} data-id="element-184" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-185">
            <h4 className="font-serif text-white text-lg mb-6" data-id="element-186">Explore</h4>
            <ul className="space-y-3" data-id="element-187">
              <li data-id="element-188">
                <Link to="/explore" className="text-sm hover:text-secondary transition-colors" data-id="element-189">
                  All Properties
                </Link>
              </li>
              <li data-id="element-190">
                <Link to="/explore?tier=1" className="text-sm hover:text-secondary transition-colors" data-id="element-191">
                  Tier 1 Listings
                </Link>
              </li>
              <li data-id="element-192">
                <Link to="/map" className="text-sm hover:text-secondary transition-colors" data-id="element-193">
                  Map Discovery
                </Link>
              </li>
              <li data-id="element-194">
                <Link to="/list-property" className="text-sm hover:text-secondary transition-colors" data-id="element-195">
                  List Your Property
                </Link>
              </li>
              <li data-id="element-196">
                <Link to="/about" className="text-sm hover:text-secondary transition-colors" data-id="element-197">
                  About AMU
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-198">
            <h4 className="font-serif text-white text-lg mb-6" data-id="element-199">
              Legal & Trust
            </h4>
            <ul className="space-y-3" data-id="element-200">
              <li data-id="element-201">
                <Link to="/about" className="text-sm hover:text-secondary transition-colors" data-id="element-202">
                  Terms & Conditions
                </Link>
              </li>
              <li data-id="element-203">
                <Link to="/about" className="text-sm hover:text-secondary transition-colors" data-id="element-204">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-205">
                <Link to="/about" className="text-sm hover:text-secondary transition-colors" data-id="element-206">
                  Verification Process
                </Link>
              </li>
              <li data-id="element-207">
                <Link to="/about" className="text-sm hover:text-secondary transition-colors" data-id="element-208">
                  Fraud Prevention
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-209">
            <h4 className="font-serif text-white text-lg mb-6" data-id="element-210">Contact</h4>
            <ul className="space-y-4" data-id="element-211">
              <li className="flex items-start gap-3" data-id="element-212">
                <MapPin size={18} className="text-secondary shrink-0 mt-0.5" data-id="element-213" />
                <span className="text-sm" data-id="element-214">
                  14 Maitama Crescent, Abuja, FCT, Nigeria
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-215">
                <Phone size={18} className="text-secondary shrink-0" data-id="element-216" />
                <span className="text-sm" data-id="element-217">+234 (0) 70 39340610</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-218">
                <Mail size={18} className="text-secondary shrink-0" data-id="element-219" />
                <span className="text-sm" data-id="element-220">support@amu.ng</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Trust Banner & Copyright */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-221">
          <div className="flex items-center gap-2 text-sm text-white/70" data-id="element-222">
            <ShieldCheck size={18} className="text-success" data-id="element-223" />
            <span data-id="element-224">
              All listings are subject to AGIS/FCDA verification standards.
            </span>
          </div>
          <p className="text-sm text-white/50" data-id="element-225">
            &copy; {new Date().getFullYear()} AMU Real Estate. All rights
            reserved.
          </p>
        </div>

        {/* Designed by Credit */}
        <div className="mt-6 pt-6 border-t border-white/5 text-center" data-id="element-226">
          <p className="text-xs text-white/40 tracking-wider uppercase" data-id="element-227">
            Designed by{' '}
            <a href="#" className="text-secondary hover:text-secondary-dark font-semibold transition-colors" data-id="element-228">
              KM Consulting & Tech LTD
            </a>
          </p>
        </div>
      </div>
    </footer>;
};